// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__CM5BJ","noposts":"Dashboard_noposts__EIwSN","post_header":"Dashboard_post_header__QPRVU","post_row":"Dashboard_post_row__He64C"};